import { observer } from 'mobx-react';

import AltSkuField from '@/catalog/components/AltSkuField/AltSkuField';
import SetupPreset from '@/media/entity/SetupPreset';
import ProductLink from '@/product/components/ProductLink/ProductLink';
import ProductPrice from '@/product/components/ProductPrice/ProductPrice';
import { ProductEntity } from '@/product/types';

import styles from './ProductInfo.module.css';

interface ProductInfoProps {
  product: ProductEntity;
  setupPreset?: Nullable<SetupPreset>;
  showPrice?: boolean;
  showTitle?: boolean;
  showB2BSid?: boolean;
  showAltSku?: boolean;
  mediaSize?: Nullable<string>;
}

function ProductInfo(props: ProductInfoProps) {
  const {
    product,
    setupPreset,
    showPrice = true,
    showTitle = true,
    showB2BSid = true,
    showAltSku = false,
    mediaSize,
  } = props;

  return (
    <div>
      <div className={styles.productInfoDesc}>
        {showB2BSid && (
          <ProductLink
            className={styles.productInfoShortView}
            product={product}
            setupPreset={setupPreset}
            text={product.b2bSid}
            aria-label="Product B2B SID link"
          />
        )}

        {showTitle && (
          <ProductLink className={styles.productInfoShortView} product={product} setupPreset={setupPreset} />
        )}

        {showAltSku && <AltSkuField className={styles.productInfoShortView} value={product.altSku ?? ''} />}
      </div>

      {showPrice && <ProductPrice product={product} mediaSize={mediaSize} />}
    </div>
  );
}

export default observer(ProductInfo);
